import { useCallback } from 'react';
import { isVehicle } from '@features/vehiclesearch';
import type { Vehicle, VehicleDerivative } from '@features/vehiclesearch';
import type { SmriqConfirmedVehicle } from '../types/smriq.types';

/** A mileage/annual override is synced back onto the quote vehicle (never the reg, its
 *  identity) through the non-invalidating action: selectVehicle would clear this session. */
interface UseSmriqConfirmedVehicleSyncArgs {
    selectedVehicle: Vehicle | VehicleDerivative | null;
    setSmriqConfirmedVehicle: (snapshot: SmriqConfirmedVehicle | null) => void;
    syncSmriqConfirmedMileage: (mileage: { mileage: number; annualMileage: number }) => void;
}

export function useSmriqConfirmedVehicleSync({
    selectedVehicle,
    setSmriqConfirmedVehicle,
    syncSmriqConfirmedMileage,
}: UseSmriqConfirmedVehicleSyncArgs) {

    return useCallback(
        (snapshot: SmriqConfirmedVehicle | null) => {
            setSmriqConfirmedVehicle(snapshot);
            if (!snapshot || !selectedVehicle || !isVehicle(selectedVehicle)) return;
            const status = selectedVehicle.current_status;
            if (
                status?.mileage === snapshot.currentMileage &&
                status?.annual_mileage === snapshot.annualMileage
            ) {
                return;
            }
            syncSmriqConfirmedMileage({
                mileage: snapshot.currentMileage,
                annualMileage: snapshot.annualMileage,
            });
        },
        [setSmriqConfirmedVehicle, syncSmriqConfirmedMileage, selectedVehicle],
    );
}
